import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './app/pages/Home';
import ThankYou from './app/pages/ThankYou';
import AlreadySponsored from './app/pages/AlreadySponsored';
export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/sponsored" element={<AlreadySponsored />} />
      </Routes>
    </Router>
  );
};